export const TEXT_IMAGE_LAYOUTS = {
  textMedia: 'lg:order-1',
  mediaText: 'lg:order-0',
} as const;

type ObjectValues<T> = T[keyof T];
export type TextImageLayoutType = ObjectValues<typeof TEXT_IMAGE_LAYOUTS>;
